import axios from 'axios';

import { backendRequestHeaders, getBackendBaseUrl } from '@/api/backendAuth';

export interface SyncPaddleTenantBillingResult {
  packageId: string;
  packageName: string;
  paddleCustomerId?: string | null;
  paddleSubscriptionId?: string | null;
}

export async function fetchSyncPaddleTenantBilling(sessionJwt?: string | null): Promise<SyncPaddleTenantBillingResult> {
  const base = getBackendBaseUrl();
  const { data } = await axios.post<SyncPaddleTenantBillingResult>(
    `${base}/billing/paddle/sync-tenant-billing`,
    {},
    { headers: backendRequestHeaders(sessionJwt) },
  );
  return data;
}
